import { API } from '../utils/constants'

const services = {
  list: API + '/interactions',
  delete: API + '/interactions',
  detail: API + '/interactions',
  register: API + '/interactions',
  status: API + '/interactions',
}

export async function getAllInteractions(quotation: number) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.list}/${quotation}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateInteraction(body: any, id: number) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.status}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteInteraction(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.delete}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function newInteraction(body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(services.register, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
